<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    />
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 210"
      :items-per-page="20"
      :footer-props="{
        'items-per-page-options': [10, 20, 40, 60, 80, 100],
      }"
      :search="search"
      fixed-header
      must-sort
      :loading="loaderStatus"
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.surname }}</td>
          <td>{{ item.documenttype }}</td>
          <td>{{ item.documentno }}</td>
          <td v-if="item.expire">
            <v-icon :color="item.expired ? 'red' : 'green'">{{ item.expired ? mdiCloseThick : mdiCheckBold }}</v-icon>
            {{ item.expire | moment($store.state.auth.df.date) }}
          </td>
          <td v-else />
          <td>{{ item.country }}</td>
          <td>
            <v-btn icon @click="((visitor = { ...item }), listVisitorDocumentsLoad(item.id))">
              <v-icon>{{ mdiFileDocumentMultiple }}</v-icon>
            </v-btn>
          </td>
          <td v-if="$store.state.auth.userSettings.accVisitors.update" class="px-2 tableSelectCursor">
            <v-btn icon @click="((dialogEdit = true), (visitor = { ...item }))">
              <v-icon>{{ mdiPen }}</v-icon>
            </v-btn>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accVisitors.write" block color="colorNew" @click="dataNew">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
      <v-spacer />
      <v-col cols="2">
        <v-btn v-if="$store.state.auth.userSettings.accVisitors.export" block color="colorExport" href="/api/v1/export/visitors">
          {{ $t('btn.export') }}
          <v-icon>{{ mdiExport }}</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="2">
        <v-btn v-if="$store.state.auth.userSettings.accVisitors.import" block color="colorImport" @click="dialogImport = true">
          {{ $t('btn.import') }}
          <v-icon>{{ mdiImport }}</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="dialogEdit" persistent width="70%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.visitor') }}
          <v-spacer />
          <v-icon large @click="dialogEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form v-model="validForm" ref="visitorForm">
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :label="$t('label.name')"
                  v-model="visitor.name"
                  maxlength="64"
                  hide-details
                  dense
                  :rules="[ruleRequired]"
                  autofocus
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="$t('label.surname')"
                  v-model="visitor.surname"
                  maxlength="64"
                  hide-details
                  dense
                  :rules="[ruleRequired]"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :label="$tc('label.documentType')"
                  v-model="visitor.documenttype"
                  :items="listDocumentTypes"
                  item-text="comboBoxName"
                  item-value="type"
                  cache-items
                  append-icon="$dropdown"
                  dense
                  hide-details
                  clearable
                  :rules="[ruleRequired]"
                  :prepend-inner-icon="mdiCardAccountDetails"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="$t('label.documentno')"
                  v-model="visitor.documentno"
                  maxlength="64"
                  hide-details
                  dense
                  :rules="[ruleRequired]"
                  :prepend-inner-icon="mdiCardAccountDetails"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  :label="$tc('label.country')"
                  v-model="visitor.country"
                  :items="listCountries"
                  item-text="comboBoxName"
                  item-value="A3"
                  cache-items
                  append-icon="$dropdown"
                  dense
                  hide-details
                  clearable
                  :prepend-inner-icon="mdiEarth"
                />
              </v-col>
              <v-col cols="6">
                <v-menu
                  ref="dateMenu"
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateFormatted"
                      :label="$t('label.expire')"
                      :append-icon="mdiCalendar"
                      @blur="visitor.expire = momentParse(dateFormatted)"
                      :rules="[ruleValidDate]"
                      hide-details
                      dense
                      v-on="on"
                      :prepend-inner-icon="mdiLockClock"
                      autocomplete="off"
                    />
                  </template>
                  <v-date-picker
                    :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
                    v-model="visitor.expire"
                    no-title
                    @input="dateMenu = false"
                  />
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  :label="$t('label.phone')"
                  v-model="visitor.phone"
                  maxlength="64"
                  hide-details
                  dense
                  :prepend-inner-icon="mdiPhone"
                />
              </v-col>
              <v-col cols="6">
                <v-text-field
                  :label="$t('label.email')"
                  v-model="visitor.email"
                  maxlength="256"
                  hide-details
                  dense
                  :prepend-inner-icon="mdiEmail"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="visitor.company"
                  :label="$tc('label.company')"
                  :items="listCompanies"
                  :return-object="true"
                  append-icon="$dropdown"
                  item-text="name"
                  item-value="id"
                  hide-details
                  dense
                  clearable
                  :prepend-inner-icon="mdiOfficeBuilding"
                />
              </v-col>
              <v-col cols="6">
                <v-autocomplete
                  v-model="visitor.car"
                  :label="$tc('label.car')"
                  :items="listCars"
                  :return-object="true"
                  append-icon="$dropdown"
                  item-text="plate"
                  item-value="id"
                  hide-details
                  dense
                  clearable
                  :prepend-inner-icon="mdiCarSide"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <v-text-field v-model="visitor.notify" :label="$t('label.visitorNotify')" hide-details />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-textarea v-model="visitor.note" name="input-7-1" :label="$t('label.note')" no-resize hide-details dense />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-btn v-if="visitor.id && $store.state.auth.userSettings.accVisitors.delete" color="colorDelete" @click="dialogDelete = true">
            {{ $t('btn.delete') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="colorSave" @click="dataSave">{{ $t('btn.save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogImport" max-width="60vw">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.import') }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="importEvent"
                :label="$t('label.action')"
                :items="listImportEvents"
                hide-details
                append-icon
                auto-select-first
              />
            </v-col>
            <v-spacer />
            <v-col cols="2">
              <v-progress-circular v-if="importProgressStatus" :size="40" color="green" indeterminate />
            </v-col>
            <v-col cols="3">
              <v-btn block color="colorImport" class="mt-2">
                <label for="appLogFileInput">{{ $t('btn.csvFile') }}</label>
                <input
                  id="appLogFileInput"
                  v-on:change="((importFile = $event.target.files), (importFileName = $event.target.files[0].name))"
                  type="file"
                  hidden
                />
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <h3>{{ importFileName }}</h3>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn tile color="colorImport" @click="dataImport">{{ $t('btn.import') }}</v-btn>
          <v-spacer />
          <v-btn tile color="colorClose" @click="dialogImport = false">{{ $t('btn.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogVisitorDocuments" persistent width="70%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $t('label.visitorDocuments') }}
          <v-spacer />
          <v-icon large @click="dialogVisitorDocuments = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-data-table
            :headers="listDocumentsHeaders"
            :items="listVisitorDocuments"
            item-key="id"
            :height="$store.state.windowSize.y - 400"
            :items-per-page="20"
            :footer-props="{
              'items-per-page-options': [10, 20, 40, 60, 80, 100],
            }"
            fixed-header
            must-sort
            :loading="loaderStatus"
            class="tableCursor"
          >
            <template v-slot:item="{ item }">
              <tr>
                <td class="pl-2">{{ item.templateName }}</td>
                <td class="pl-2">{{ item.signTime }}</td>
                <td class="pl-2">{{ item.validUntil }}</td>
                <td>
                  <v-btn icon @click="getVisitorDocuments(item.id)">
                    <v-icon>{{ mdiPrinter }}</v-icon>
                  </v-btn>
                </td>
                <td>
                  <v-btn
                    v-if="$store.state.auth.userSettings.accVisitors.delete"
                    icon
                    @click="((documentUUID = item.id), (dialogDeleteDocument = true))"
                  >
                    <v-icon color="colorDelete">{{ mdiDelete }}</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}: ${visitor.name} ${visitor.surname}?`"
      :openDialog.sync="dialogDelete"
      v-on:confirm="dataDelete"
    />
    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}?`"
      :openDialog.sync="dialogDeleteDocument"
      v-on:confirm="deleteVisitorDocument(documentUUID)"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';

import {
  mdiMagnify,
  mdiPen,
  mdiClose,
  mdiCalendar,
  mdiEmail,
  mdiPhone,
  mdiPrinter,
  mdiOfficeBuilding,
  mdiCarSide,
  mdiEarth,
  mdiCardAccountDetails,
  mdiLockClock,
  mdiCloseThick,
  mdiCheckBold,
  mdiImport,
  mdiExport,
  mdiFileDocumentMultiple,
  mdiDelete,
} from '@mdi/js';

export default Vue.extend({
  name: 'SettingsVisitors',
  components: { DialogConfirmDelete },
  data: () => ({
    dialogEdit: false,
    dialogDelete: false,
    dialogDeleteDocument: false,
    dialogImport: false,
    dialogVisitorDocuments: false,
    documentUUID: '',
    validForm: false,
    loaderStatus: false,
    tableData: [],
    search: '',
    dateFormatted: '',
    dateMenu: false,
    listCompanies: [],
    listCars: [],
    listCountries: [],
    listDocumentTypes: [],
    listVisitorDocuments: [], // Dokumenty z podpisoveho terminalu
    visitor: {
      id: 0,
      name: '',
      surname: '',
      documentno: '',
      documenttype: '',
      expire: '',
      country: '',
      phone: '',
      email: '',
      company: {
        id: 0,
      },
      car: {
        id: 0,
      },
      note: '',
      notify: '',
    },
    importFile: '',
    importFileName: '',
    importProgressStatus: false,
    importEvent: 'append',
    mdiMagnify: mdiMagnify,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
    mdiCalendar: mdiCalendar,
    mdiEmail: mdiEmail,
    mdiPhone: mdiPhone,
    mdiPrinter: mdiPrinter,
    mdiEarth: mdiEarth,
    mdiOfficeBuilding: mdiOfficeBuilding,
    mdiCarSide: mdiCarSide,
    mdiCardAccountDetails: mdiCardAccountDetails,
    mdiLockClock: mdiLockClock,
    mdiCloseThick: mdiCloseThick,
    mdiCheckBold: mdiCheckBold,
    mdiImport: mdiImport,
    mdiExport: mdiExport,
    mdiFileDocumentMultiple: mdiFileDocumentMultiple,
    mdiDelete: mdiDelete,
  }),
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    ruleValidDate() {
      return (v: any) =>
        v == '' || this.$moment(v, this.$store.state.auth.df.date, true).isValid() || this.$i18n.t('msg.invalidDateFormat');
    },
    headers: function () {
      return [
        { text: this.$i18n.t('label.name'), value: 'name' },
        { text: this.$i18n.t('label.surname'), value: 'surname' },
        { text: this.$i18n.tc('label.documentType'), value: 'documenttype' },
        { text: this.$i18n.t('label.documentno'), value: 'documentno' },
        { text: this.$i18n.t('label.expire'), value: 'expire' },
        { text: this.$i18n.tc('label.country'), value: 'country' },
        { sortable: false, width: '48px' },
        { sortable: false, width: '48px' },
      ];
    },
    listDocumentsHeaders: function () {
      return [
        { text: this.$i18n.tc('label.printTemplate'), value: 'templateName' },
        { text: this.$i18n.t('label.signDate'), value: 'signTime' },
        { text: this.$i18n.t('label.expire'), value: 'validUntil' },
        { sortable: false, width: '48px' },
        { sortable: false, width: '48px' },
      ];
    },
    listImportEvents: function () {
      return [
        { text: this.$i18n.t('label.append'), value: 'append' },
        { text: this.$i18n.t('label.rewrite'), value: 'rewrite' },
      ];
    },
  },
  watch: {
    'visitor.expire'() {
      var date: string = this.$moment(this.visitor.expire).format(this.$store.state.auth.df.date);
      if (date !== 'Invalid date') {
        this.dateFormatted = date;
      } else {
        this.$store.commit('globalMessage', this.$i18n.t('msg.errInvalidExpire'));
        this.visitor.expire = '';
        this.dateFormatted = '';
      }
    },
  },
  mounted() {
    this.listCompaniesLoad();
    this.listCarsLoad();
    this.listCountriesLoad();
    this.listDocumentTypesLoad();
    this.$nextTick(function () {
      this.dataLoad();
    });
  },
  methods: {
    dataLoad() {
      this.loaderStatus = true;
      axios
        .get('/api/v1/visitor')
        .then((response) => {
          for (const visitor of response.data) {
            if (visitor.company.id !== 0) {
              let company: {
                id: 0;
              };
              for (company of this.listCompanies) {
                if (company.id === visitor.company.id) {
                  visitor.company = { ...company };
                  break;
                }
              }
              // Ak nenasiel firmu tak zmaz
              if (visitor.company.name === undefined) {
                delete visitor.company;
              }
            } else {
              delete visitor.company;
            }
          }
          this.tableData = response.data;
          this.loaderStatus = false;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
          this.loaderStatus = false;
        });
    },
    dataNew() {
      const getDefaults: any = this.$options;
      this.visitor = { ...getDefaults.data().visitor };
      this.dialogEdit = true;
      this.$nextTick(function () {
        const form: any = this.$refs.visitorForm;
        form.validate();
      });
    },
    dataSave() {
      this.$nextTick(() => {
        const form: any = this.$refs.visitorForm;
        if (form.validate() !== true) {
          this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
        } else {
          if (this.visitor.id === 0) {
            axios
              .post('/api/v1/visitor', this.visitor)
              .then(() => {
                this.dataLoad();
                this.dialogEdit = false;
              })
              .catch((err) => {
                this.$store.dispatch('catchErrHandler', err);
              });
          } else {
            axios
              .put('/api/v1/visitor', this.visitor)
              .then(() => {
                this.dataLoad();
                this.dialogEdit = false;
              })
              .catch((err) => {
                this.$store.dispatch('catchErrHandler', err);
              });
          }
        }
      });
    },
    dataDelete() {
      axios
        .delete(`/api/v1/visitor/${this.visitor.id}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.dialogEdit = false;
      this.dialogDelete = false;
    },
    listCompaniesLoad() {
      axios
        .get('/api/v1/company')
        .then((response) => {
          this.listCompanies = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listCarsLoad() {
      axios
        .get(`/api/v1/car`)
        .then((response) => {
          this.listCars = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listCountriesLoad() {
      axios
        .get('/api/v1/countries')
        .then((response) => {
          for (const country of response.data) {
            country.comboBoxName = country.A3 + ' - ' + country.czShort;
          }
          this.listCountries = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listDocumentTypesLoad() {
      axios
        .get(`/api/v1/documenttype`)
        .then((response) => {
          for (const docType of response.data) {
            docType.comboBoxName = docType.type + ' - ' + docType.name;
          }
          this.listDocumentTypes = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listVisitorDocumentsLoad(visitorID: number) {
      axios
        .get(`/api/v1/visitordocuments/${visitorID}`)
        .then((response) => {
          this.listVisitorDocuments = response.data;
          let doc: {
            signTime: string;
            validDays: number;
            validUntil: string;
          };
          for (doc of this.listVisitorDocuments) {
            doc.signTime = this.$moment(doc.signTime).format(this.$store.state.auth.df.date);
            doc.validUntil = this.$moment(doc.validUntil).add(doc.validDays, 'days').format(this.$store.state.auth.df.date);
          }
          this.dialogVisitorDocuments = true;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataImport() {
      if (this.importFileName === '') {
        this.$store.commit('globalMessage', this.$i18n.t('msg.selectImportFile'));
        return;
      }
      this.importProgressStatus = true;
      const formData = new FormData();
      formData.append('upload', this.importFile[0]);
      axios
        .post(`/api/v1/import/visitors/${this.importEvent}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(() => {
          this.importProgressStatus = false;
          this.dataLoad();
          this.dialogImport = false;
        })
        .catch((err) => {
          this.importProgressStatus = false;
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    momentParse(inputDate: string) {
      return this.$moment(inputDate, this.$store.state.auth.df.date, true).isValid()
        ? this.$moment(inputDate, this.$store.state.auth.df.date).format('YYYY-MM-DD')
        : '';
    },
    deleteVisitorDocument(id: string) {
      axios
        .delete(`/api/v1/trandoc/${id}`)
        .then(() => {
          this.listVisitorDocumentsLoad(this.visitor.id);
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        })
        .finally(() => {
          this.dialogDeleteDocument = false;
        });
    },
    getVisitorDocuments(id: string) {
      if (this.$store.state.appMode === 'electron') {
        const link = document.createElement('a');
        link.href = `/api/v1/trandoc/${id}`;
        link.setAttribute('download', 'tranDoc.pdf');
        document.body.appendChild(link);
        link.click();
      } else {
        let printWin = window.open(
          `/api/v1/trandoc/${id}`,
          'portunus-print-window',
          'location=no,titlebar=no,toolbar=no,status=no,menubar=no,width=1024,height=900',
        );
        if (printWin === null) {
          alert(this.$i18n.t('msg.popupRequired'));
          return;
        }
        printWin!.addEventListener(
          'load',
          () => {
            printWin!.focus();
            // printWin!.print();
          },
          false,
        );
      }
    },
  },
});
</script>
